<template>
  <el-dialog custom-class="webpay product" :visible.sync="visibleInner" top="1vh">
    <span slot="title">
      <h4 v-if="id">{{ $t('edit') }}</h4>
      <h4 v-if="!id">{{ $t('add') }}</h4>
    </span>
    <div v-loading="loading">
      <el-form
        ref="productForm"
        @submit.native.prevent="save"
        :show-message="false"
        :model="model"
        :rules="rules"
      >
        <el-form-item :label="$t('product_name')" prop="name">
          <el-input size="mini" v-model="model.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('sku')" prop="sku">
          <el-input size="mini" v-model="model.sku"></el-input>
        </el-form-item>
        <el-form-item :label="$t('price')" prop="price">
          <el-input size="mini" v-model="model.price"></el-input>
        </el-form-item>
        <el-form-item :label="$t('currency')" prop="currency_id">
          <el-select v-model="model.currency_id" size="medium">
            <el-option
              v-for="currency in currencies"
              :key="currency.value"
              :label="currency.label"
              :value="currency.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('language')" prop="language_id">
          <el-select v-model="model.language_id" size="medium">
            <el-option
              v-for="language in languages"
              :key="language.value"
              :label="$t(language.label)"
              :value="language.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('active')" prop="active">
          <el-checkbox v-model="model.active"></el-checkbox>
        </el-form-item>

        <el-button class="aligner right" round type="primary" native-type="submit">{{ $t('save') }}</el-button>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import apiRes from '../../core/apiRes'

export default {
  name: 'product-modal',
  props: ['url', 'callback', 'visible', 'id'],
  computed: {
    visibleInner: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  },
  data() {
    return {
      loading: true,
      model: { name: '', sku: '', status: '1', active: true, currency_id: '', price: '', language_id: '' },
      rules: {
        name: { required: true, trigger: 'blur' },
        sku: { required: true, trigger: 'blur' },
        currency_id: { required: true, trigger: 'blur' },
        price: { required: true, trigger: 'blur' },
        language_id: { required: true, trigger: 'blur' }
      },
      link: '',
      currencies: [],
      languages: []
    }
  },
  created() {
    this.loading = true
    apiRes.get(this.url).then(data => data.page_vars).then((data) => {
      var currencies = data.currency_menu_arr.currency_id
      if (currencies) {
        this.currencies = Object.keys(currencies).filter(k => k !== 'selected_id').map(key => {
          return {
            label: key,
            value: currencies[key]
          }
        })
      }
      var languages = data.language_arr.lang
      if (languages) {
        this.languages = Object.keys(languages).map(key => {
          return {
            label: key,
            value: languages[key]
          }
        })
      }
      if (data.v) {
        Object.assign(this.model, data.v)
        this.model.language_id = data.language_id
        this.model.currency_id = data.cur
        this.link = data.link_product
      } else {
        this.model.language_id = Object.keys(data.language_arr.selected)[0]
        this.model.currency_id = currencies.selected_id
      }
      this.model.active = this.model.status === '1'
    }).catch(() => {
      this.$notify.error({
        title: this.$t('error'),
        message: ''
      })
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    save() {
      this.$refs['productForm'].validate(valid => {
        if (valid) {
          this.loading = true
          let toSend = { action_type: 'submit' }
          Object.assign(toSend, this.model)
          toSend.status = toSend.active ? 1 : 0
          // delete toSend.active
          if (this.id) {
            toSend.product_id = this.id
          }
          apiRes
            .post(this.url, toSend)
            .then(res => {
              if (res.page_vars) {
                this.callback(res.page_vars)
                this.visibleInner = false
              }

              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style>
.el-dialog.webpay.product {
  max-width: 532px;
}
</style>
